import useAuthUser from "../../hooks/useAuthUser";
import OrganizationCard from "./OrganizationCard";
import OrganizationReportees from "./OrganizationReportees";

const OrganizationHierarchy = ({
  hierarchy = [],
  reportees = [],
  photoPath,
  onClick = () => {},
  loggedInUserManagerId = null,
  highlightedUserId = null,
}) => {
  const { loggedInUser } = useAuthUser();
  const currentLoggedInUserId = Number(loggedInUser?.id);
  const userRole = Number(loggedInUser?.role);
  const isEmployeeRole = userRole === 7;
  const isManagerRole = userRole === 8 || userRole === 4 || userRole === 5;

  if (!hierarchy || hierarchy.length === 0) return null;

  const reporteeCards = reportees.length ? (
    <OrganizationReportees
      managerName={hierarchy[hierarchy.length - 1]?.userName}
      people={reportees}
      photoPath={photoPath}
      onClick={onClick}
      highlightedUserId={highlightedUserId}
    />
  ) : null;

  return (
    <div className="org-chart">
      {hierarchy.map((user, index) => {
        const isCurrentUserManager = user.userId === loggedInUserManagerId;

        let clickHandler = null;

        if (isEmployeeRole || isManagerRole) {
          clickHandler = isCurrentUserManager ? onClick : null;
        } else {
          clickHandler = onClick;
        }

        if (!clickHandler && isManagerRole) {
          clickHandler = user.userId === currentLoggedInUserId ? onClick : null;
        }

        return (
          <OrganizationCard
            key={user.userId}
            user={user}
            hasMore={index < hierarchy.length - 1 || reportees.length > 0}
            photoPath={photoPath}
            onClick={clickHandler}
            highlightedUserId={highlightedUserId}
          />
        );
      })}
      {reporteeCards}
    </div>
  );
};

export default OrganizationHierarchy;
